import { VerificationCompleteStatus } from '@endeavour/verification-integration';
import { VerificationTypeError } from '@endeavour/verification-integration/src/interface/errors.interface';

function mapError(error) {
    switch (error.type) {
        case 'exception':
            return VerificationTypeError.VALIDATION_ERROR;
        case 'expired_token':
            return VerificationTypeError.EXPIRED_TOKEN;
        default:
            return VerificationTypeError.UNKNOWN_ERROR;
    }
}
const createOnfidoIntegration = () => {
    return {
        async initialize(params) {
            const { init } = await import('onfido-sdk-ui');
            const completeHandlers = [];
            const errorHandlers = [];
            const configSteps = params.providerConfig.steps;
            const div = document.createElement('div');
            params.container.appendChild(div);
            const token = await params.getSession();
            const instance = init({
                token: token.sessionId,
                containerEl: div,
                useModal: true,
                isModalOpen: true,
                onComplete: function (data) {
                    completeHandlers.forEach((handler) => {
                        handler(VerificationCompleteStatus.COMPLETE_SUCCESS, data);
                    });
                },
                onError: function (data) {
                    errorHandlers.forEach((handler) => {
                        handler({ code: mapError(data), success: false });
                    });
                },
                onModalRequestClose: function () {
                    instance.setOptions({ isModalOpen: false });
                    completeHandlers.forEach((handler) => {
                        handler(VerificationCompleteStatus.USER_CANCELLED);
                    });
                },
                steps: configSteps,
            });
            const result = {
                onProcessComplete: (handler) => {
                    completeHandlers.push(handler);
                    return () => {
                        const index = completeHandlers.indexOf(handler);
                        if (index === -1) {
                            throw new Error('Handler already destroyed!');
                        }
                        completeHandlers.splice(index, 1);
                    };
                },
                onError: (handler) => {
                    errorHandlers.push(handler);
                    return () => {
                        const index = errorHandlers.indexOf(handler);
                        if (index === -1) {
                            throw new Error('Handler already destroyed!');
                        }
                        errorHandlers.splice(index, 1);
                    };
                },
                destroy: () => {
                    completeHandlers.splice(0, completeHandlers.length);
                    errorHandlers.splice(0, errorHandlers.length);
                    instance.tearDown();
                },
                success: true,
            };
            return result;
        },
    };
};

export { createOnfidoIntegration };
